const pms_transaction_type = [
  {
    value: "commercial",
    name: "Commercial",
  },
  {
    value: "residential",
    name: "Residential",
  },
];

export default pms_transaction_type;



// WEBPACK FOOTER //
// ./src/constants/pms_transaction_type.js